<template>
    <div>
        <ConfirmSave ref="confirmSave" @submit="submitShift"/>
        <CRow style="margin-top: 24px;margin-bottom: 36px;">
            <CCol sm="10">
                <h4 class="font-weight-bold">Detail Shift</h4>
            </CCol>
            <CCol sm="2">
                <CButton @click="saveShifting()" type="button" class="btn btn-add">
                    <span v-if="loading == false">Simpan</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
        <CRow v-for="(li, id) in dataDetail">
            <CCol sm="2">
                <span>{{ li }}</span>
            </CCol>
            <CCol sm="1">
                <span style="float: right;">:</span>
            </CCol>
            <CCol sm="5">
                <span v-if="datas.length != 0" class="font-weight-bold">{{ datas[dataValue[id]] }}</span>
            </CCol>
        </CRow>
        <CRow>
            <CCol sm="10"></CCol>
            <CCol sm="2">
                <CButton @click="addData()" type="button" class="btn btn-add">Tambah</CButton>
            </CCol>
        </CRow>
        <CRow style="margin-top: 24px;">
            <CCol sm="12">
                <TablesDetail @edit="editData" @delete="confirmDelete" :data="dataTable.jadwalShift" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="dataTable.jadwalShift.length == 0 ? 'Data tidak ditemukan' : ''"></TablesDetail>
            </CCol>
        </CRow>
        <PopUpAdd ref="popUpAdd" @saveShift="saveShift"/>
        <ConfirmDelete ref="confirmDelete" @goDelete="deletaData"/>
    </div>
</template>
<script>
import TablesDetail from '../../../component/tableShiftDetail'
import { DataApi } from '../../../service/DataApi'
import PopUpAdd from './PopUpAdd.vue'
import ConfirmSave from './ConfirmSave.vue'
import ConfirmDelete from './ConfirmDelete.vue'

export default {
    components: {
        TablesDetail,
        PopUpAdd,
        ConfirmSave,
        ConfirmDelete
    },
    data() {
        return {
            loading: false,
            datas: [],
            dataTable: [],
            dataDetail: [
                'Nama Pegawai',
                'Nomor Induk Pegawai',
                'Email',
                'Unit Level',
                'Periode'
            ],
            dataValue: [
                'nama',
                'nip',
                'email',
                'unit',
                'bulanTahunText'
            ],


            dataTh: [
                'Hari',
                'Tanggal',
                'Jam Mulai Kerja',
                'Jam Mulai Istirahat',
                'Jam Selesai Istirahat',
                'Jam Selesai Kerja',
                'Deskripsi',
                'Action'
            ],
            dataTd: [
                'hari',
                'tanggal',
                'kerjaMasuk',
                'istirahatKeluar',
                'istirahatMasuk',
                'kerjaKeluar',
                'deskripsi',
                'actions'
            ],
            styleTable: ['50px', '100px', '100px', '100px', '100px', '100px', '100px', '100px'],
            errorMessage: '',
        }
    },
    methods: {
        saveShift(value) {
            if(value.flagEdit == '1') {
                this.dataTable.jadwalShift.splice(value.ids, 1)
            }
            this.dataTable.jadwalShift.push(value.data)
            this.$refs.popUpAdd.closePopUp()
        },
        saveShifting() {
            this.loading = true
            let dt = this.dataTable
            let payload = {
                bulan: dt.bulan,
                idPegawai: dt.idPegawai,
                jadwal: dt.jadwalShift,
                tahun: dt.tahun
            }
            DataApi.post('shift/jadwal/validasi', payload)
            .then( res => {
                let resp = res.data
                this.loading = false
                this.$refs.confirmSave.dataDetail = resp.success == true ? resp.data : null
                this.$refs.confirmSave.datas = resp.success == true ? payload : null
                this.$refs.confirmSave.isShownConfirm = true
            })
        },
        clearData() {
            this.datas = []
            this.dataTable = []
        },
        editData(value) {
            this.$refs.popUpAdd.ids = value
            this.$refs.popUpAdd.dataDetail = {...this.dataTable.jadwalShift[value]}
            this.$refs.popUpAdd.isEdit = '1'
            this.showAdd()
        },
        addData() {
            this.$refs.popUpAdd.ids = ''
            this.$refs.popUpAdd.dataDetail = []
            this.$refs.popUpAdd.isEdit = '0'
            this.showAdd()
        },
        showAdd() {
            this.$refs.popUpAdd.isShown = true
        },
        confirmDelete(value) {
            this.$refs.confirmDelete.datas = value
            this.$refs.confirmDelete.isShownDelete = true
        },
        deletaData(value) {
            this.dataTable.jadwalShift.splice(value, 1)
            this.$refs.confirmDelete.closePopUp()
        },
        submitShift(value) {
            DataApi.post('shift/jadwal/simpan', value)
            .then( res => {
                let response = res.data
                let success = ''
                let alertMess = ''
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        success = true
                    } else {
                        success = false
                    }
                    alertMess = response.data.Data2
                } else {
                    alertMess = response.message
                    success = false
                }
                let onPush = {
                    mess: alertMess,
                    succ: success
                }
                this.$emit('backFront', onPush)
                this.$refs.confirmSave.closePopUp()
                this.clearData()
            })
        }
    },
}
</script>

<style scoped>
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}</style>